<template>
  <ElDialog
    ref="dialog"
    title
    :visible.sync="btnDialog"
    :close-on-click-modal="false"
    append-to-body
    :width="$device.mobile ? '100%' : '30%'"
    :show-close="isClose"
    :top="marginTop"
    custom-class="btn-dialog"
  >
    <template #title>
      <div v-if="status === 's' || status === 'f'">
        <ElImage v-if="status === 's'" class="w-90 h-90" :src="require('@/assets/icon/success-lg.png')" alt />
        <em v-if="status === 'f'" class="iconfont red fs-30">&#xe62c;</em>
      </div>
    </template>
    <div class="content">
      <span v-html="msg"></span>
      <div class="max-h-300 overflow-auto">
        <Agreement v-if="btnDialog && isArguments" :save-direct="true" />
      </div>
    </div>
    <template #footer>
      <div class="footer">
        <div v-if="noOff === 1">
          <ElButton @click="btnDialog = false">{{ $t('login.cancel') }}</ElButton>
        </div>
        <div v-if="noOff === 2">
          <ElButton type="warning" @click="btnDialog = false">{{ $t('dialog.CreateLater') }}</ElButton>
        </div>
        <div>
          <ElButton type="primary" @click="fun_confirm">{{ btnName }}</ElButton>
        </div>
      </div>
    </template>
  </ElDialog>
</template>
<script>
import Agreement from '@/views/personal/modules/kyc/agreement/index.vue'
export default {
  name: 'BtnDialog',
  components: {
    Agreement
  },
  props: {
    hideClose: {
      type: Boolean
    }
  },
  data() {
    return {
      isClose: false,
      btnDialog: false,
      isArguments: false,
      status: '',
      msg: '',
      fun_funtion: '',
      noOff: -1,
      btnName: '',
      fun_cancel: '',
      message: {}
    }
  },
  computed: {
    marginTop() {
      if (this.$device.mobile) {
        return `50vh`
      } else {
        return '15vh'
      }
    }
  },
  watch: {
    message(val) {
      this.btnDialog = val.isdialog
      this.status = val.status
      this.msg = val.msg
      this.isArguments = val.isArguments
      this.fun_funtion = val.fun_funtion
      this.noOff = Number(val.noOff)
      this.btnName = val.btnName
      this.fun_cancel = val.fun_cancel
    },
    btnDialog(n, o) {
      if (n !== o && !n) {
        this.cancel()
      }
    }
  },
  created() {
    if (typeof this.hideClose === 'boolean') {
      this.isClose = this.hideClose
    }
  },
  mounted() {
    this.Bus.$on('btnMessage', (ev) => {
      this.message = ev
    })
  },
  methods: {
    fun_confirm() {
      this.fun_funtion()
      this.btnDialog = false
    },
    cancel() {
      this.fun_cancel && this.fun_cancel()
      this.btnDialog = false
    }
  }
}
</script>
<style lang="scss">
.btn-dialog {
  @include global.response_to(('mobile')) {
    transform: translateY(-50%);
  }
}
</style>
